(function () {
  'use strict';

  var MIN_QUERY_LENGTH = 2;
  var DEBOUNCE_MS = 170;

  var QUERY_ALIASES = [
    { pattern: /\b(?:spry|spryg|sprygr|sprygro|sprygrou|sprygroun|spryground|sprygrund|spraygrund|spraygroun|spray\s+ground)\b/gi, value: 'sprayground' },
    { pattern: /\b(?:san|sain|saint)\s*(?:bart|barth|bat)\b/gi, value: 'saint barth' },
    { pattern: /\bmc\s*2\b/gi, value: 'mc2' },
    { pattern: /\bk\s*[- ]?\s*way\b/gi, value: 'k-way' },
    { pattern: /\bgoorin\s*(?:bros|brothers?)?\b/gi, value: 'goorin bros' },
    { pattern: /\bdevid\s*label\b/gi, value: 'devid label' }
  ];

  function normalizeText(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function correctQuery(value) {
    var corrected = (value || '').toString().trim();
    QUERY_ALIASES.forEach(function (alias) {
      corrected = corrected.replace(alias.pattern, alias.value);
    });
    return corrected.replace(/\s+/g, ' ').trim();
  }

  function safePath(value) {
    if (!value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.origin !== window.location.origin) return '';
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return '';
    }
  }

  function safeImage(value) {
    if (!value) return '';
    var source = typeof value === 'string' ? value : (value.url || value.src || '');
    if (!source) return '';
    if (source.indexOf('//') === 0) return window.location.protocol + source;
    try {
      var parsed = new URL(source, window.location.origin);
      return /^https?:$/.test(parsed.protocol) ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function imageFromResource(resource) {
    return safeImage(
      resource && (
        resource.featured_image ||
        resource.image ||
        resource.featured_media ||
        resource.featured_image_url
      )
    );
  }

  function imageAlt(resource) {
    var image = resource && (resource.featured_image || resource.image || {});
    return (image && image.alt) || (resource && resource.title) || '';
  }

  function priceText(value, locale, currency) {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value === 'string' && /[€$£]|\b(?:EUR|USD|GBP)\b/i.test(value)) return value;

    var normalized = typeof value === 'number' ? value : Number(String(value).replace(',', '.').replace(/[^0-9.-]/g, ''));
    if (!Number.isFinite(normalized)) return String(value);

    try {
      return new Intl.NumberFormat(locale || 'it-IT', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(normalized);
    } catch (error) {
      return normalized.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function emit(name, detail) {
    var payload = Object.assign({ event: name, component: 'search_v2' }, detail || {});
    window.dispatchEvent(new CustomEvent('devid:search-v2', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  function init(root) {
    if (root.dataset.searchV2Ready === 'true') return;
    root.dataset.searchV2Ready = 'true';

    var form = root.querySelector('[data-search-v2-form]');
    var input = root.querySelector('[data-search-v2-input]');
    var clearButton = root.querySelector('[data-search-v2-clear]');
    var emptyState = root.querySelector('[data-search-v2-empty]');
    var loading = root.querySelector('[data-search-v2-loading]');
    var correction = root.querySelector('[data-search-v2-correction]');
    var destinationsSection = root.querySelector('[data-search-v2-destinations]');
    var destinationsList = root.querySelector('[data-search-v2-destinations-list]');
    var productsSection = root.querySelector('[data-search-v2-products]');
    var productsList = root.querySelector('[data-search-v2-products-list]');
    var noResults = root.querySelector('[data-search-v2-no-results]');
    var allResults = root.querySelector('[data-search-v2-all-results]');
    var allResultsCopy = root.querySelector('[data-search-v2-all-results-copy]');
    var status = root.querySelector('[data-search-v2-status]');

    if (!form || !input || !destinationsList || !productsList) return;

    var rootUrl = (root.getAttribute('data-root-url') || '/').trim();
    if (rootUrl.slice(-1) !== '/') rootUrl += '/';
    var locale = (root.getAttribute('data-locale') || document.documentElement.lang || 'it-IT').trim();
    var currency = (root.getAttribute('data-currency') || 'EUR').trim();
    var isEnglish = locale.toLowerCase().indexOf('en') === 0;
    var timer = null;
    var controller = null;
    var requestSequence = 0;

    function setHidden(node, hidden) {
      if (node) node.hidden = Boolean(hidden);
    }

    function resetResults(showEmpty) {
      destinationsList.innerHTML = '';
      productsList.innerHTML = '';
      setHidden(destinationsSection, true);
      setHidden(productsSection, true);
      setHidden(noResults, true);
      setHidden(allResults, true);
      setHidden(correction, true);
      setHidden(loading, true);
      setHidden(emptyState, !showEmpty);
      if (status) status.textContent = '';
    }

    function setLoading(isLoading) {
      setHidden(loading, !isLoading);
      if (isLoading) {
        setHidden(emptyState, true);
        setHidden(noResults, true);
      }
      root.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function destinationCard(item) {
      var link = document.createElement('a');
      link.className = 'search-v2__destination';
      link.href = item.url;
      link.setAttribute('data-search-v2-result-type', item.kind);

      var media = document.createElement('span');
      media.className = 'search-v2__destination-media';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.alt || item.title;
        img.loading = 'lazy';
        img.decoding = 'async';
        media.appendChild(img);
      } else {
        media.classList.add('search-v2__destination-media--brand');
        media.textContent = (item.title || '').slice(0, 2);
      }

      var copy = document.createElement('span');
      copy.className = 'search-v2__destination-copy';
      var kind = document.createElement('small');
      kind.className = 'search-v2__destination-kind';
      kind.textContent = item.kind === 'brand' ? (isEnglish ? 'Brand' : 'Brand') : (isEnglish ? 'Collection' : 'Collezione');
      var title = document.createElement('strong');
      title.className = 'search-v2__destination-title';
      title.textContent = item.title;
      copy.appendChild(kind);
      copy.appendChild(title);

      var arrow = document.createElement('span');
      arrow.className = 'search-v2__destination-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';

      link.appendChild(media);
      link.appendChild(copy);
      link.appendChild(arrow);
      link.addEventListener('click', function () {
        emit(item.kind === 'brand' ? 'search_brand_clicked' : 'search_collection_clicked', { title: item.title, query: input.value.trim() });
      });
      return link;
    }

    function productCard(product) {
      var destination = safePath(product.url);
      if (!destination) return null;

      var link = document.createElement('a');
      link.className = 'search-v2__product';
      link.href = destination;

      var media = document.createElement('span');
      media.className = 'search-v2__product-media';
      var image = imageFromResource(product);
      if (image) {
        var img = document.createElement('img');
        img.src = image;
        img.alt = imageAlt(product);
        img.loading = 'lazy';
        img.decoding = 'async';
        media.appendChild(img);
      }

      var copy = document.createElement('span');
      copy.className = 'search-v2__product-copy';

      if (product.vendor) {
        var vendor = document.createElement('span');
        vendor.className = 'search-v2__product-vendor';
        vendor.textContent = product.vendor;
        copy.appendChild(vendor);
      }

      var title = document.createElement('strong');
      title.className = 'search-v2__product-title';
      title.textContent = product.title || '';
      copy.appendChild(title);

      var price = priceText(product.price || product.price_min, locale, currency);
      var compareAt = priceText(product.compare_at_price_max || product.compare_at_price, locale, currency);
      if (price) {
        var priceRow = document.createElement('span');
        priceRow.className = 'search-v2__product-price';
        var current = document.createElement('span');
        current.textContent = price;
        priceRow.appendChild(current);
        if (compareAt && compareAt !== price) {
          var old = document.createElement('s');
          old.textContent = compareAt;
          priceRow.appendChild(old);
        }
        copy.appendChild(priceRow);
      }

      link.appendChild(media);
      link.appendChild(copy);
      link.addEventListener('click', function () {
        emit('search_product_clicked', { title: product.title || '', vendor: product.vendor || '', query: input.value.trim() });
      });
      return link;
    }

    function buildBrandDestination(products, correctedQuery) {
      var counts = {};
      products.forEach(function (product) {
        var vendor = (product.vendor || '').trim();
        if (!vendor) return;
        var key = normalizeText(vendor);
        if (!counts[key]) counts[key] = { vendor: vendor, count: 0, image: imageFromResource(product) };
        counts[key].count += 1;
        if (!counts[key].image) counts[key].image = imageFromResource(product);
      });

      var queryKey = normalizeText(correctedQuery);
      var candidates = Object.keys(counts).map(function (key) { return counts[key]; });
      candidates.sort(function (a, b) { return b.count - a.count; });
      var match = candidates.find(function (candidate) {
        var vendorKey = normalizeText(candidate.vendor);
        return queryKey.indexOf(vendorKey) !== -1 || vendorKey.indexOf(queryKey) !== -1;
      });
      if (!match || match.count < 1) return null;

      return {
        kind: 'brand',
        title: match.vendor,
        image: match.image,
        alt: match.vendor,
        url: rootUrl + 'search?type=product&q=' + encodeURIComponent(match.vendor)
      };
    }

    function renderResults(rawQuery, correctedQuery, resources) {
      var products = Array.isArray(resources.products) ? resources.products.slice(0, 8) : [];
      var collections = Array.isArray(resources.collections) ? resources.collections.slice(0, 4) : [];
      var destinations = [];
      var seenDestinationUrls = {};

      var brand = buildBrandDestination(products, correctedQuery);
      if (brand) {
        destinations.push(brand);
        seenDestinationUrls[brand.url] = true;
      }

      collections.forEach(function (collection) {
        var url = safePath(collection.url);
        if (!url || seenDestinationUrls[url]) return;
        seenDestinationUrls[url] = true;
        destinations.push({
          kind: 'collection',
          title: collection.title || '',
          url: url,
          image: imageFromResource(collection),
          alt: imageAlt(collection)
        });
      });

      destinationsList.innerHTML = '';
      destinations.slice(0, 5).forEach(function (item) {
        destinationsList.appendChild(destinationCard(item));
      });

      productsList.innerHTML = '';
      products.forEach(function (product) {
        var card = productCard(product);
        if (card) productsList.appendChild(card);
      });

      var destinationCount = destinationsList.childElementCount;
      var productCount = productsList.childElementCount;
      var hasResults = destinationCount + productCount > 0;

      setHidden(destinationsSection, destinationCount === 0);
      setHidden(productsSection, productCount === 0);
      setHidden(noResults, hasResults);
      setHidden(emptyState, true);
      setHidden(allResults, false);

      var allResultsUrl = rootUrl + 'search?type=product&q=' + encodeURIComponent(correctedQuery);
      allResults.href = allResultsUrl;
      if (allResultsCopy) {
        allResultsCopy.textContent = isEnglish
          ? 'View all results for “' + correctedQuery + '”'
          : 'Vedi tutti i risultati per “' + correctedQuery + '”';
      }

      if (normalizeText(rawQuery) !== normalizeText(correctedQuery)) {
        correction.innerHTML = isEnglish
          ? 'Results for <strong></strong>'
          : 'Risultati per <strong></strong>';
        correction.querySelector('strong').textContent = correctedQuery;
        setHidden(correction, false);
        emit('search_typo_corrected', { raw_query: rawQuery, corrected_query: correctedQuery });
      } else {
        setHidden(correction, true);
      }

      if (status) {
        status.textContent = isEnglish
          ? productCount + ' products and ' + destinationCount + ' destinations found.'
          : productCount + ' prodotti e ' + destinationCount + ' destinazioni trovate.';
      }

      emit(hasResults ? 'search_results_rendered' : 'search_zero_results', {
        query: rawQuery,
        corrected_query: correctedQuery,
        product_count: productCount,
        destination_count: destinationCount
      });
    }

    async function search(rawQuery) {
      var correctedQuery = correctQuery(rawQuery);
      if (correctedQuery.length < MIN_QUERY_LENGTH) {
        if (controller) controller.abort();
        resetResults(true);
        return;
      }

      requestSequence += 1;
      var sequence = requestSequence;
      if (controller) controller.abort();
      controller = new AbortController();
      setLoading(true);

      var params = new URLSearchParams();
      params.set('q', correctedQuery);
      params.set('resources[type]', 'product,collection,query');
      params.set('resources[limit]', '8');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'hide');
      params.set('resources[options][fields]', 'title,vendor,product_type,variants.title');

      try {
        var response = await fetch(rootUrl + 'search/suggest.json?' + params.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error('predictive_search_' + response.status);
        var payload = await response.json();
        if (sequence !== requestSequence) return;
        var resources = payload && payload.resources && payload.resources.results ? payload.resources.results : {};
        renderResults(rawQuery, correctedQuery, resources);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        if (sequence !== requestSequence) return;
        destinationsList.innerHTML = '';
        productsList.innerHTML = '';
        setHidden(destinationsSection, true);
        setHidden(productsSection, true);
        setHidden(emptyState, true);
        setHidden(noResults, false);
        setHidden(allResults, false);
        allResults.href = rootUrl + 'search?type=product&q=' + encodeURIComponent(correctedQuery);
        emit('search_request_failed', { query: rawQuery });
      } finally {
        if (sequence === requestSequence) setLoading(false);
      }
    }

    input.addEventListener('input', function () {
      var value = input.value.trim();
      clearButton.hidden = !value;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { search(value); }, DEBOUNCE_MS);
    });

    input.addEventListener('search', function () {
      if (!input.value) {
        clearButton.hidden = true;
        resetResults(true);
      }
    });

    clearButton.addEventListener('click', function () {
      input.value = '';
      clearButton.hidden = true;
      if (controller) controller.abort();
      resetResults(true);
      input.focus({ preventScroll: true });
      emit('search_cleared');
    });

    form.addEventListener('submit', function () {
      var corrected = correctQuery(input.value);
      if (corrected) input.value = corrected;
      emit('search_submitted', { query: corrected });
    });

    allResults.addEventListener('click', function () {
      emit('search_all_results_clicked', { query: input.value.trim() });
    });

    resetResults(true);
    emit('search_v2_ready');
  }

  document.querySelectorAll('[data-search-v2]').forEach(init);
})();
